import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { AssignmentInputButtonContainer } from '../../../styles/assignment/assignment'

//Registration schema
const schema = yup.object().shape({
    subject: yup.string().required("Subject is a required field"),
    description: yup.string().required("Description is a required field"),
});

const AssignmentUpload = () => {

    const [imageUploadValue, setImageUploadValue] = useState('')

    const {
        handleSubmit,
        register,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Upload Solution
                        </Heading>
                        <Breadcrumb
                            crumbs={['Assignments', "Upload Solution"]}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Input
                                    id="assignmentSolutionTitle"
                                    label="SOLUTION TITLE"
                                    type="text"
                                    placeholder="English Language JSS 1 Solutions"
                                    fullWidth
                                />
                            </InputWrapper>

                            <InputWrapper>
                                <AssignmentInputButtonContainer >
                                    <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </AssignmentInputButtonContainer>
                            </InputWrapper>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AssignmentUpload
